import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const FAQS = [
  {
    q: "Est-ce que je dois gérer l'opportunité moi-même ?",
    a: "Non. Tu déposes l'opportunité dans Leadzi. Nos équipes analysent le besoin et te font une proposition.",
  },
  {
    q: "Dois-je être fournisseur pour utiliser Leadzi ?",
    a: "Non. Leadzi CHR s'adresse aux commerciaux qui rencontrent des opportunités qu'ils ne peuvent pas traiter.",
  },
  {
    q: "Combien puis-je gagner ?",
    a: "Le montant proposé dépend de la qualité, de la nature et du potentiel de l'opportunité.",
  },
  {
    q: "Dois-je contacter le client après avoir déposé l'opportunité ?",
    a: "Une fois l'opportunité déposée, Leadzi analyse le besoin et t'indique la marche à suivre directement dans l'application. Tu n'as rien à gérer de ton côté tant que tu n'as pas reçu de proposition.",
  },
  {
    q: "Est-ce que toutes les opportunités sont retenues ?",
    a: "Non. Leadzi analyse les opportunités et décide si elles correspondent à ses critères.",
  },
  {
    q: "Comment recevoir l'application ?",
    a: "Télécharge simplement Leadzi CHR depuis l'App Store ou Google Play.",
  },
];

const Item = ({ item, open, onToggle, index }) => (
  <div
    data-testid={`faq-item-${index}`}
    className={`overflow-hidden rounded-2xl border transition-colors ${open ? "border-brand/30 bg-brand-light/50" : "border-black/5 bg-white"}`}
  >
    <button
      onClick={onToggle}
      className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
    >
      <span className="text-base font-bold text-ink sm:text-lg">{item.q}</span>
      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${open ? "rotate-45 bg-brand text-white" : "bg-[#FAFAFA] text-ink"}`}>
        <Plus className="h-4 w-4" />
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="px-6 pb-6 text-base leading-relaxed text-ink/60">{item.a}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="scroll-mt-20 bg-[#FAFAFA] py-20 lg:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <Overline>FAQ</Overline>
          <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
            Les questions que tu te poses.
          </h2>
        </Reveal>

        <div data-testid="faq-accordion-container" className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.05}>
              <Item item={f} index={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
